import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { viewManageOrderRowsData } from "../viewOrder/ViewOrderType";
import { Button } from "@mui/material";
import {
  createScrollHandler,
  handleScroll,
  truncateToTwoDecimals,
} from "../../components/dms_common/DmsUtils";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import TextSwitcher, {
  TextSwitcherItemObject,
} from "../../components/dms_common/TextSwitcher";
import { getDataFromLocalDb } from "../../services/dbService";
import { getConfigData } from "../../services/configurationService";
import { OrderType } from "../../types/types";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import dayjs from "dayjs";
import BorderHeading from "../../components/heading/BorderHeading";
import "./ViewPrimaryOrderOMSTest.css";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import FormHeader from "../../components/dms_common/FormHeader";
import CircularProgress from "@mui/material/CircularProgress";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Cart, Catalogue } from "../createSecondaryOrder/models";
import {
  createCartProductFromCatalogue,
  getCurrentDateTimeFormat,
  getValidateRequestBody,
  prepareOrderReqBody,
  // updateMultiQtyInCart,
  // updateQuantityInCart,
} from "../createSecondaryOrder/CreateSecondaryOrderService";
import {
  updateOrderStatus,
  updateOrder,
  createInvoice,
  updateInvoiceStatus,
  getSinglePrimaryOrder,
  getReferenceOrdersOms,
} from "../../services/manageOrderService";
import { Loader } from "../../components/loader/Loader";
import {
  checkForEmptyTable,
  checkAllRowsHaveValidStock,
  createAndDownloadInvoicePdf,
  getBatchCodes,
  getOrderTotalRowData,
  initialDiscountState,
  modifyCartToValidate,
  prepareEditOrderReqBody,
  getGenericModalProps,
  initialGenericModalProps,
  GenericModal,
  buttonLoading,
  customStyle,
  showOverlayIn,
  createSkuWiseStockMap,
  transformedStatusForProgressCardV2,
  stages,
  transformValidateResponse,
  prepareSaveChangesReqBody,
} from "../viewOrder/ViewOrderUtils";
import { init } from "ace-builds/src-noconflict/ext-keybinding_menu";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import SearchV2 from "../../components/dms_common/SearchV2";
import { getMetaData1ViewPrimaryOMSV2 } from "../viewPrimaryOrder/ViewPrimaryOrderConfig";
import CustomAccordianV2 from "../../components/dms_common/CustomAccordianV2";
import {
  createCatalogue,
  performUomConversionPrimary,
} from "../../services/catalogueService";
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import { getViewPrimaryOrderOmsConfigV2Final } from "../viewOrder/ViewOrderConfig";
import OrderProgressCardV2 from "../viewOrder/OrderProgressCardV2";
import CustomTablewithTotalInfoV2 from "../../components/dms_common/CustomTablewithTotalInfoV2";
import { ChannelkartNetworkPost } from "../../services/networkService";
import OrderCancelModal from "../viewOrder/OrderCancelModal";

const ViewPrimaryOrderOMSTest = () => {
  const { orderId } = useParams();
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );

  const navigate = useNavigate();
  const location = useLocation();

  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [cloningActive, setCloningActive] = useState<boolean>(false);

  const [rows, setRows] = useState<viewManageOrderRowsData[]>([]);


  const [loader, setLoader] = useState(true);
  const [textSwitcherItems, setTextSwitcherItems] = useState<
    TextSwitcherItemObject[]
  >([]);

  const [isScrolling, setIsScrolling] = useState(false);
  const [clickSaveChangesLoading, setClickSaveChangesLoading] =
    useState<boolean>(false);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);
  const [disableActionButtons, setDisableActionButtons] = useState(false);
  const [lineCount, setLineCount] = useState<number>();

  const [showAddMoreButton, setShowAddMoreButton] = useState<boolean>(false);


  const [selectedRejectionReason, setSelectedRejectionReason] =
    useState<string>(``);
  const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);
  const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
  const siteWarehouseMappingRef = useRef<any>({});
  const [deliveryDatePrimary, setDeliveryDatePrimary] = useState<string>("");

  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [orderData, setOrderData] = useState<any>({});
  const showCompanyStockOMS = useRef<boolean>(false);

  const resetGenericModalProps = () =>
    setGenericModalProps(initialGenericModalProps);

  const [orderStatusChangeLoading, setOrderStatusChangeLoading] =
    useState<string>("");
  const [searchedValue, setSearchedValue] = useState<string>("");

  const [addMoreLoading, setAddMoreLoading] = useState(false);
  const [hasReferenceOrders, setHasReferenceOrders] = useState(false);

  const disableSchemeCheck = useRef<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const [cart, setCart] = useState<Cart>({});
  const disableStockCheck = useRef<boolean>(false);

  // add addMoreLoading to this if needed, check later

  const [editLoading, setEditLoading] = useState<boolean>(false);
  const [orderCancelModalOpen, setOrderCancelModalOpen] =
    useState<boolean>(false);

  // Checkbox selection state
  const [checkedIdArray, setCheckedIdArray] = useState<any[]>([]);

  const showOverlay: boolean =
    showOverlayIn?.includes(orderStatusChangeLoading) ||
    editLoading ||
    clickSaveChangesLoading;

  const [totalQ, setTotalQ] = useState(0);
  const [totalW, setTotalW] = useState(0);
  const [totalF, setTotalF] = useState(0);

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  // Get selected rows data
  const getSelectedRowsData = () => {
    return rows.filter((row) => checkedIdArray.includes(row.id));
  };

  useEffect(() => {
    const data = getSelectedRowsData();

    let totalFinalAmount = 0;
    let totalConvertedCases = 0;
    let totalWeight = 0;

    data.forEach((row:any) => {
      // Sum actualAmount safely
      totalFinalAmount += Number(row.finalAmount || 0);
      totalWeight += row?.wt ?? 0

      // Get product info using batchCode

      const foundCatalogue = catalogue.find(
        (catalogue: any) => catalogue.batchCode === row.batchCode
      );

      const caseToPieceQuantity = foundCatalogue?.case2Piece ?? 0;
      const otherUnitToPieceQty = foundCatalogue?.otherUnitToPieceQuantity ?? 0;

      // Calculate converted cases per row
      const convertedCases =
        row.caseQuantity +
        (foundCatalogue?.otherUnitToPieceQuantity === 0
          ? 0
          : row.otherUnitQuantity *
            (otherUnitToPieceQty / caseToPieceQuantity)) +
        (caseToPieceQuantity === 0
          ? 0
          : row.pieceQuantity / caseToPieceQuantity);

      totalConvertedCases += Math.trunc(convertedCases);
    });
    
    setTotalF(totalFinalAmount);
    setTotalW(totalWeight)
    setTotalQ(totalConvertedCases);
  }, [checkedIdArray]);

  // Get selectable row IDs (exclude free items)
  const getSelectableRowIds = () => {
    return rows
      .filter((row) => !row.freeItem && row.id &&  !row?.alreadySplitted) // Exclude free items and rows without ID
      .map((row) => row.id);
  };

  const handleRemove = (paramRow: any) => {
    if (!cloningActive) {
      // updateMultiQtyInCart(
      //   paramRow?.batchCode,
      //   {
      //     caseQuantity: 0,
      //     otherUnitQuantity: 0,
      //     pieceQuantity: 0,
      //   },
      //   { outletCode: orderData?.outletCode },
      //   catalogue,
      //   setCart
      // );
    }
    setRows((prevRows) => prevRows?.filter((row) => row?.id !== paramRow?.id));
  };
  const [allowedRows, setAllowedRows] = useState<any>(getSelectableRowIds());

  useEffect(() => {
    if (rows?.some((row) => row?.isNew)) {
      setCloningActive(true);
    } else {
      setCloningActive(false);
    }
    if (
      rows?.some((row) => row?.isNew || row?.hasChanged) ||
      hasRealChanges()
    ) {
      setCheckedIdArray([]);
      setAllowedRows([]);
    } else {
      setAllowedRows(getSelectableRowIds());
    }
  }, [rows]);

  const handleClone = (paramRow: any) => {
    const clonedRow = {
      ...paramRow,

      id: crypto.randomUUID(),

      hasChanged: true,
      isNew: true,
      lineCount:undefined,
      caseQuantity: 0,
      otherUnitQuantity: 0,
      pieceQuantity: 0,
      actualCaseQuantity: 0,
      actualOtherUnitQuantity: 0,
      actualPieceQuantity: 0,
      actualAmount: "0",
      totalConvertedCasesPrimaryOMS: 0,
      skuDiscountInfo: [
        {
          discountType: "Coupon",
          discountAmount: 0,
        },
        {
          discountType: "Scheme",
          discountAmount: 0,
        },
      ],
      taxInfo: [],
      finalAmount: 0,
    };
    // setRows((prevRows) => {
    //   const index = prevRows.findIndex((row) => row.id === paramRow.id);
    //   if (index === -1) return [...prevRows, clonedRow]; 
      
    //   // Insert cloned row right after the source row
    //   const newRows = [...prevRows];
    //   newRows.splice(index + 1, 0, clonedRow);
    //   return newRows;
    // });
    setRows((prevRows) => {
    const index = prevRows.findIndex((row) => row.id === paramRow.id);
    let newRows;
    
    if (index === -1) {
      newRows = [...prevRows, clonedRow];
    } else {
      newRows = [...prevRows];
      newRows.splice(index + 1, 0, clonedRow);
    }
    
    // Sort to keep alreadySplitted rows at the end
    return newRows.sort((a, b) => {
      if (a.alreadySplitted === b.alreadySplitted) return 0;
      return a.alreadySplitted ? 1 : -1;
    });
  });
    // setRows((prevRows) => [...prevRows, clonedRow]);
  };

  const fetchRequiredConfigs = async () => {
    try {
      const stages = ConfigDictionary?.primaryOrderTrackingStages;
      stages.unshift({
        id: "ALLORDERS",
        color: "#F0F3FF",
        label: "All Orders",
        labelColor: "",
      });
      const rejectionReasonsConfig = await getConfigData(
        "dms_configuration",
        "orderCancellationReasons"
      );

      const res8 = await getConfigData("dms_configuration", "showAddMorePrimaryOms");    
      setShowAddMoreButton(res8[0]?.configValue ?? false)
      const res7 = await getConfigData(
        "dms_configuration",
        "disableSchemeCheck"
      );
      //   const res4 = await getConfigData("dms_configuration", "hideItemLevelTaxInfo");
      //   const res5 = await getConfigData("dms_configuration", "hideOrderProgressCard");
      //   const kgbplDeliveryMetadataConfig = await getConfigData("dms_configuration", "showKGBPLOrderSummary");
      //   kgbplDeliveryMetadata.current = kgbplDeliveryMetadataConfig[0]?.configValue ??false;

      //   const res6 = await getConfigData("order_configuration", "goToInvoiceRedirectionButton");

      //   const res9 = await getConfigData("dms_configuration", "showCancelOrderButton");
      const res10 = await getConfigData(
        "dms_configuration",
        "showCompanyStockOMS"
      );
      //   setPushToGrnButton(res8[0]?.configValue ?? false)
      //   setCancelOrderButton(res9[0]?.configValue ?? false)

      disableSchemeCheck.current = res7[0]?.configValue ?? false;
      //   hideAddMoreInEditOrder.current = res[0]?.configValue ?? false;
      //   disableEditInvoiceFlow.current = true;
      disableStockCheck.current = true;
      //   hideItemLevelTaxInfo.current = res4[0]?.configValue ?? false;
      //   hideOrderProgressCard.current = res5[0]?.configValue ?? false;
      //   showGoToInvoiceRedirectionButton.current = res6[0]?.configValue ?? false;
      showCompanyStockOMS.current = res10[0]?.configValue ?? false;

      setRejectionReasons(rejectionReasonsConfig?.[0]?.configValue ?? []);
      setOrderTrackingConfig(stages ?? []);

      if (ConfigDictionary?.showSiteWarehouseFilterViewPrimaryOMS) {
        const dbResult = await getDataFromLocalDb("SiteWarehouseIdMapping");
        siteWarehouseMappingRef.current = dbResult?.data?.[0]?.data ?? {};
      }
    } catch (e) {
      console.error("Error while fetching configs", e);
    }
  };
  const handleSkuLevelSiteChange = (
    row: viewManageOrderRowsData,
    siteId: string
  ) => {
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === row.id
          ? { ...r, siteAllSku: siteId, warehouseAllSku: "", hasChanged: true ,lineCount:undefined}
          : r
      )
    );
  };

  const handleSkuLevelWarehouseChange = (
    row: viewManageOrderRowsData,
    warehouseId: string
  ) => {
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === row.id
          ? { ...r, warehouseAllSku: warehouseId, hasChanged: true,lineCount:undefined }
          : r
      )
    );
    console.log(
      `Updated warehouseAllSku for SKU ${row.batchCode} to ${warehouseId}`
    );
  };
  const handleQuantityChange = (
    paramRow: any,
    changedQuantity: number,
    type: UOM
  ) => {
    if (changedQuantity >= 0) {
      const quantityKey =
        type === UOM.CASE
          ? "caseQuantity"
          : type === UOM.OTHER
          ? "otherUnitQuantity"
          : "pieceQuantity";
      const priceKey =
        type === UOM.CASE
          ? "casePrice"
          : type === UOM.OTHER
          ? "otherUnitPrice"
          : "price";

      if (!cloningActive) {
        // updateQuantityInCart(
        //   paramRow?.batchCode,
        //   changedQuantity,
        //   type,
        //   { outletCode: orderData?.outletCode },
        //   catalogue,
        //   setCart
        // );
      }

      const product = createCartProductFromCatalogue(
        catalogue,
        paramRow?.batchCode
      );

      const caseToPieceQuantity = product?.case2Piece ?? 0;
      const otherUnitToPieceQty = product?.otherUnit2Piece ?? 0;

      setRows((prevRows) =>
        prevRows?.map((row) => {
          if (row?.id !== paramRow?.id) return row;

          // Use updated quantities for calculation
          const updatedCaseQty =
            type === UOM.CASE ? changedQuantity : row.caseQuantity ?? 0;
          const updatedOtherQty =
            type === UOM.OTHER ? changedQuantity : row.otherUnitQuantity ?? 0;
          const updatedPieceQty =
            type === UOM.PIECE ? changedQuantity : row.pieceQuantity ?? 0;

          const convertedCases =
            updatedCaseQty +
            (caseToPieceQuantity > 0 && otherUnitToPieceQty > 0
              ? updatedOtherQty * (otherUnitToPieceQty / caseToPieceQuantity)
              : 0) +
            (caseToPieceQuantity > 0
              ? updatedPieceQty / caseToPieceQuantity
              : 0);

              const newActualAmount =
                Number(row?.actualAmount) -
                paramRow[quantityKey] * paramRow[priceKey] +
                changedQuantity * paramRow[priceKey];

              const allZero =
                updatedCaseQty === 0 &&
                updatedOtherQty === 0 &&
                updatedPieceQty === 0;

              const finalActualAmount = allZero ? 0 : Math.max(newActualAmount, 0); 

          const newRow = {
            ...row,
            [quantityKey]: changedQuantity,
            actualAmount: String(finalActualAmount),
            totalConvertedCasesPrimaryOMS: convertedCases,

            skuDiscountInfo: [
              {
                discountType: "Coupon",
                discountAmount: 0,
              },
              {
                discountType: "Scheme",
                discountAmount: 0,
              },
            ],
            taxInfo: [],
            finalAmount: "0",
            hasChanged: true,
          };

          const hasChanged =
            newRow?.actualCaseQuantity !== newRow?.caseQuantity ||
            newRow?.actualPieceQuantity !== newRow?.pieceQuantity ||
            newRow?.actualOtherUnitQuantity !== newRow?.otherUnitQuantity;

          return { ...newRow, hasChanged };
        })
      );
    }
  };
  const handleSkuReplace = (
    row: any,
    newBatchCode: string,
    newSkuDescription: string
  ) => {
    console.log("sku selected", row, newBatchCode);
    const newRowId = crypto.randomUUID();
  
    const product = createCartProductFromCatalogue(catalogue, newBatchCode);
  
    const caseToPieceQuantity = product?.case2Piece ?? 0;
    const otherUnitToPieceQty = product?.otherUnit2Piece ?? 0;
  
    // Calculate converted cases per row
    const convertedCases =
      row.caseQuantity +
      (product?.otherUnit2Piece === 0
        ? 0
        : row.otherUnitQuantity * (otherUnitToPieceQty / caseToPieceQuantity)) +
      (caseToPieceQuantity === 0 ? 0 : row.pieceQuantity / caseToPieceQuantity);
  
    setRows((prevRows) => {
      const updatedRows = prevRows.map((r) =>
        r.id === row.id
          ? {
              ...r,
              id: newRowId,
              lineCount:undefined,
              batchCode: newBatchCode,
              skuDescription: newSkuDescription,
              casePrice: String(product?.casePrice ?? 0),
              otherUnitPrice: String(product?.otherUnitPrice ?? 0),
              price: String(product?.price ?? 0),
              totalConvertedCasesPrimaryOMS: convertedCases,
              actualAmount: String(
                (product?.casePrice ?? 0) * row.caseQuantity +
                  (product?.otherUnitPrice ?? 0) * row.otherUnitQuantity +
                  (product?.price ?? 0) * row.pieceQuantity
              ),
              skuDiscountInfo: [
                {
                  discountType: "Coupon",
                  discountAmount: 0,
                },
                {
                  discountType: "Scheme",
                  discountAmount: 0,
                },
              ],
              taxInfo: [],
              finalAmount: "0",
              hasChanged: true,
            }
          : r
      );
  
      // Sort to keep alreadySplitted rows at the end
      return updatedRows.sort((a, b) => {
        if (a.alreadySplitted === b.alreadySplitted) return 0;
        return a.alreadySplitted ? 1 : -1;
      });
    });
  };

  const viewOrderConfig = getViewPrimaryOrderOmsConfigV2Final(
    handleRemove,
    showCompanyStockOMS.current,
    siteWarehouseMappingRef.current,
    handleSkuLevelSiteChange,
    handleSkuLevelWarehouseChange,
    orderData?.status?.toUpperCase(),
    handleQuantityChange,
    handleClone,
    handleSkuReplace
  );

  const columns: any[] = viewOrderConfig?.columns;

  const getOrderDetails = async (orderId: string) => {
    try {
      setLoader(true);

      let res, data, referenceOrderData;

      res = await getSinglePrimaryOrder(orderId);
      data = res?.data?.features?.[0];
      if (!data) {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            `Order with order-number : ${orderId} not found`
          )
        );
      }

      if (data?.status?.toUpperCase() === "PENDING" || data?.status?.toUpperCase() === "SPLITTED" ) {
        referenceOrderData = await getReferenceOrdersOms(data?.orderNumber);
        referenceOrderData = referenceOrderData?.data?.features;
      
        const splittedIds = new Set<string>();
      
        // Collect all retainIds from reference orders
        if (referenceOrderData && Array.isArray(referenceOrderData)) {
          referenceOrderData.forEach((refOrder: any) => {
            refOrder.orderDetails?.forEach((detail: any) => {
              const retainId = detail?.extendedAttributes?.retainId;
              if (retainId) {
                splittedIds.add(retainId);
              }
            });
          });
        }
      
        // Mark alreadySplitted for current orderDetails based on id match
        data?.orderDetails?.forEach((item: any) => {
          item.alreadySplitted = splittedIds.has(item.id);
        });
      
        setHasReferenceOrders(referenceOrderData?.length > 0);
      }
      
      const validLines = data?.orderDetails?.filter(
        (item:any) => item.type !== "freeItem"
      );
      setLineCount(validLines?.length ?? 0);
      console.log("Total SKU", validLines?.length)

      const orderFulfillmentConfigPrimary =
        ConfigDictionary?.orderFulfillmentTimePrimary
          ? ConfigDictionary?.orderFulfillmentTimePrimary
          : 2;

      setDeliveryDatePrimary(
        dayjs(data?.creationTime)
          .add(orderFulfillmentConfigPrimary, "day")
          .format("YYYY-MM-DD HH:mm:ss")
      );

      await setDataRowAndFooter(data ?? {});
    } catch (err) {
      console.error(err);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Order with order-number : ${orderId} not found`
        )
      );
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setDisableActionButtons(hasRealChanges());
  }, [rows, checkedIdArray]);

  useEffect(() => {
  setRows((prevRows) =>
    prevRows.map((row) => ({
      ...row,
      isChecked: checkedIdArray.includes(row.id), // Set isChecked based on selection
    }))
  );
}, [checkedIdArray]);
  const createStockData = async (
    batchCodes: string = "",
    warehouse: string
  ) => {
    try {
      const data = await setRealTimeStockDataInDb(
        batchCodes,
        "caseQty",
        "",
        warehouse
      );
      return createSkuWiseStockMap(data);
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", "⚠️  Unable to fetch stocks data")
      );
    } finally {
    }
  };

  const setDataRowAndFooter = async (data: any) => {
    try {
      // primary catalogue
      const catalogueData = await getDataFromLocalDb("PrimaryCatalogue");
      const catalogue = catalogueData?.data ?? [];

      // fetch stocks
      let stocksData: any = {};
      const warehouseToFetchStocks = data?.extendedAttributes?.siteId ?? "";
      const orderedBatchCodes: string = getBatchCodes(data?.orderDetails) ?? "";
      stocksData = await createStockData(
        orderedBatchCodes,
        warehouseToFetchStocks
      );

      const isEditedFromPrimaryOms =
        data?.extendedAttributes?.isEditedFromPrimaryOms ?? false;

        const orderSplitFromOms = data?.extendedAttributes?.orderSplitFromOms ?? false;

      const siteAllSku =
        data?.siteId === null || data?.siteId === "null"
          ? ""
          : data?.siteId ?? "";
      const warehouseAllSku =
        data?.warehouseId === null || data?.warehouseId === "null"
          ? ""
          : data?.warehouseId ?? "";

      let dataArr: viewManageOrderRowsData[] = [];

      let taxAmount: number = 0;
      let totalOrderedQtyCases = 0;

      data?.orderDetails?.forEach((item: any, index: any) => {
        const {
          source,
          batchCode,
          price,
          casePrice,
          otherUnitPrice,
          pieceQuantity,
          caseQuantity,
          otherUnitQuantity,
          productInfo,
          creationTime,
          netAmount,
          initialAmount,
          extendedAttributes,
          type,
          discountValue,
          initialNormalizedQuantity,
          couponValue,
        } = item;

        const id = crypto.randomUUID();
        const discount = truncateToTwoDecimals(
          (discountValue ?? 0) + (couponValue ?? 0)
        );
        const finalAmount = netAmount ?? "0";

        // const finalAmount = netAmount ? truncateToTwoDecimals(netAmount) : "0";
        // const actualAmount = initialAmount
        //   ? truncateToTwoDecimals(initialAmount)
        //   : "0";
        const actualAmount = initialAmount ?? "0";
        const skuDescription = productInfo?.skuDescription ?? "-";
        // const formattedPrice = truncateToTwoDecimals(price ?? 0);
        // const formattedCasePrice = truncateToTwoDecimals(casePrice ?? 0);
        // const formattedOtherPrice = truncateToTwoDecimals(otherUnitPrice ?? 0);

        const formattedPrice = price ?? 0;
        const formattedCasePrice = casePrice ?? 0;
        const formattedOtherPrice = otherUnitPrice ?? 0;
        const freeItem: boolean =
          type === "freeItem" || item?.initialNormalizedQuantity === 0;

        const taxInfo = extendedAttributes?.taxInfo;
        if (!freeItem) {
          taxInfo?.forEach(
            (taxType: any) => (taxAmount += taxType?.taxAmount || 0)
          );
        }

        const skuDiscountInfo = [
          { discountType: "Coupon", discountAmount: couponValue ?? 0 },
          { discountType: "Scheme", discountAmount: discountValue ?? 0 },
        ];

        // setting available stock of the product
        const skuStock = stocksData?.[batchCode];

        const {
          availableCaseQty,
          availablePieceQty,
          availableOtherQty,
          committedCaseQty,
          committedPieceQty,
          committedOtherQty,
        } = skuStock || {};

        const availableStock = {
          cs: availableCaseQty || 0,
          pc: availablePieceQty || 0,
          other: availableOtherQty || 0,
          csComitted: committedCaseQty || 0,
          pcComitted: committedPieceQty || 0,
          otherComitted: committedOtherQty || 0,
        };

        const status = data?.status?.toLocaleUpperCase();

        const caseToPieceQuantity = productInfo?.caseToPieceQuantity ?? 0;
        const otherUnitToPieceQuantity =
          productInfo?.otherUnitToPieceQuantity ?? 0;

        const totalConvertedCasesPrimaryOMS = Math.trunc(
          caseQuantity +
            (otherUnitToPieceQuantity === 0
              ? 0
              : otherUnitQuantity *
                (otherUnitToPieceQuantity / caseToPieceQuantity)) +
            (caseToPieceQuantity === 0
              ? 0
              : pieceQuantity / caseToPieceQuantity)
        );

        totalOrderedQtyCases += totalConvertedCasesPrimaryOMS;

        let replacementSkuList: {
          batchCode: string;
          skuDescription: string;
        }[] = [];
        const itemId = catalogue.find(
          (item: any) => item?.batchCode === batchCode
        )?.itemId;
        if (itemId) {
          const filteredList = catalogue
            .filter((item: any) => item?.itemId === itemId)
            .map((item: any) => ({
              batchCode: item?.batchCode,
              skuDescription: item?.description,
            }));

          replacementSkuList = Array.from(
            new Map<string, { batchCode: string; skuDescription: string }>(
              filteredList.map((item: any) => [item.batchCode, item])
            ).values()
          );
        }

        dataArr.push({
          id,
          source,
          batchCode,
          skuDescription,
          caseQuantity,
          pieceQuantity,
          otherUnitQuantity,
          casePrice: formattedCasePrice,
          price: formattedPrice,
          otherUnitPrice: formattedOtherPrice,
          actualAmount,
          discount,
          finalAmount,
          creationTime,
          availableStock,
          taxInfo,
          status,
          initialCaseQuantity: caseQuantity,
          initialOtherUnitQuantity: otherUnitQuantity,
          initialPieceQuantity: pieceQuantity,
          freeItem,
          caseToPieceQty: caseToPieceQuantity,
          otherToPieceQty: otherUnitToPieceQuantity,
          initialNormalizedQuantity,
          skuDiscountInfo,
          actualCaseQuantity: caseQuantity,
          actualPieceQuantity: pieceQuantity,
          actualOtherUnitQuantity: otherUnitQuantity,
          totalConvertedCasesPrimaryOMS,
          siteAllSku: isEditedFromPrimaryOms || orderSplitFromOms ? item?.extendedAttributes?.siteId : siteAllSku,
          warehouseAllSku: isEditedFromPrimaryOms || orderSplitFromOms
            ? item?.extendedAttributes?.warehouseId
            : warehouseAllSku,
          replacementSkuList,
          isNew: false,
          hasChanged: false,
          isChecked: false,
          wt:item?.extendedAttributes?.wt ?? 0,
          alreadySplitted: item?.alreadySplitted ?? false,
          lineCount: item?.lineCount,
          retainId: item?.id
        });
      });

      dataArr.sort((a, b) => {
        if (a.alreadySplitted === b.alreadySplitted) return 0;
        return a.alreadySplitted ? 1 : -1;
      });

      setOrderData({
        ...data,
        taxAmount,
        totalConvertedCasesViewPrimaryOMS: totalOrderedQtyCases,
      });

      setRows(dataArr);

      // Clear selection when new data is loaded
      setCheckedIdArray([]);

      const res = await populateCartDuringEditOrder(data);
      if (res === "invalidPricing") {
        return;
      }
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          "Error while fetching available stock data"
        )
      );
    }
  };

  useEffect(() => {
    init();
  }, [orderId]);

  const init = async () => {
    const items: TextSwitcherItemObject[] = [
      {
        label: "Please note:",
        text: `Use dropdown to replace SKUs. Clone a line to split, add quantity, tagged as "New".`,
        svgIcon: "disclaimerIcon",
        itemStyles: {
          container: { backgroundColor: "#FFF1F1" },
          text: { color: "#B54747" },
          svg: { color: "#B54747", width: "1em" },
        },
      },
    ];

    setTextSwitcherItems(items);

    if (orderId) {
      await fetchRequiredConfigs();
      await getOrderDetails(orderId);
    } else {
      navigate("/dashboard/primaryOms/manageOrders", { replace: true });
      return;
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handler = createScrollHandler(
      scrollRef,
      isScrolling,
      setAllowTableScroll,
      setDontContainerScroll
    );

    el.addEventListener("wheel", handler);
    el.addEventListener("scroll", handler);

    return () => {
      el.removeEventListener("wheel", handler);
      el.removeEventListener("scroll", handler);
    };
  }, [isScrolling, dontAllowContainerScroll]);

  const openInvalidOrderModal = () => {
    if (!orderData?.orderNumber && !orderData?.id) {
      setGenericModalProps(
        getGenericModalProps("error", `Invalid order, cannot proceed`)
      );
      return true;
    } else {
      return false;
    }
  };

  const populateCartDuringEditOrder = async (
    data: any,
    addMore: boolean = false
  ) => {
    try {
      let orderedBatchCodes: string | string[] =
        getBatchCodes(
          data?.orderDetails
            ?.map((item: any) => (item?.type !== "freeItem" ? item : null))
            ?.filter(Boolean)
        ) ?? "";
      orderedBatchCodes = orderedBatchCodes?.split(",") ?? [];

      const pricingData = await createCatalogue(
        OrderType.PRIMARY,
        data?.outletCode,
        !disableSchemeCheck.current
        // orderedBatchCodes
      );

      if (
        pricingData &&
        Array.isArray(pricingData) &&
        pricingData?.length == 0
      ) {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "Some items in this order could not be edited due to missing/incorrect pricing data. Please update the data in the MDM & Integration Page."
          )
        );
        return "invalidPricing";
      }

      const catalogueData = await getDataFromLocalDb("PrimaryCatalogue");
      setCatalogue(catalogueData?.data);
      data?.orderDetails
        ?.filter((sku: any) => sku?.type !== "freeItem")
        ?.forEach((order: any) => {
          const {
            batchCode,
            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,
            initialNormalizedQuantity,
          } = order;
          if (initialNormalizedQuantity > 0) {
            // updateMultiQtyInCart(
            //   batchCode,
            //   {
            //     caseQuantity: caseQuantity,
            //     otherUnitQuantity: otherUnitQuantity,
            //     pieceQuantity: pieceQuantity,
            //   },
            //   { outletCode: addMore ? "self" : orderData?.outletCode },
            //   catalogueData?.data,
            //   setCart
            // );
          }
        });
    } catch (err: any) {
      console.error(err);
      if (err?.message === "pricing") {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "⚠️  Unable to fetch pricing details. Please try again later.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps);
              setIsEditing(false);
            }
          )
        );
      } else if (err?.message === "offers") {
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "⚠️  Unable to load offer details. Please refresh or try again.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps);
              setIsEditing(false);
            }
          )
        );
      } else {
        setGenericModalProps(
          getGenericModalProps("error", `Order with Id ${orderId} not found`)
        );
      }
    }
  };

  const validRows = [...rows]?.filter(
    (row: viewManageOrderRowsData) => !row?.freeItem
  );

  const handleReset = async () => {
    setSearchedValue("");
    setCheckedIdArray([]);
    await setDataRowAndFooter(orderData);
  };

  const hasRealChanges = () => {
    // Check if any real changes have been made to the order
    const validOrderData = JSON.parse(JSON.stringify(orderData));

    if (validOrderData?.orderDetails?.length !== rows?.length) return true;

    for (const row of rows) {
      if (row?.isNew || row?.hasChanged) {
        return true;
      }
    }
    return false;
  };

  const getOrderCancellationStatusId = () => {
    return "REJECTED";
  };



  const handleSaveQuantityChanges = async (filterRowsForPayload:any[]) => {
    if (clickSaveChangesLoading) return;

    setClickSaveChangesLoading(true);

    // const validOrderData = JSON.parse(JSON.stringify(orderData));
    // const validOrderDetails = validOrderData?.orderDetails?.filter(
    //   (sku: any) => sku?.type !== `freeItem`
    // );
    // validOrderData.orderDetails = validOrderDetails;

    // const newRows = rows
    // .filter((row: any) => row?.isNew === true)
    // .map((row: any) => {
    //   const foundCatalogue = catalogue.find(
    //     (catalogue: any) => catalogue.batchCode === row.batchCode
    //   );

    //   return {
    //     batchCode: row.batchCode,
    //     skuCode: row.batchCode,
    //     casePrice: foundCatalogue?.casePtr ?? 0,
    //     caseQuantity: row.caseQuantity ?? 0,
    //     otherUnitPrice: foundCatalogue?.otherUnitPtr ?? 0,
    //     otherUnitQuantity: row.otherUnitQuantity ?? 0,
    //     pieceQuantity: row.pieceQuantity ?? 0,
    //     price: foundCatalogue?.packPtr ?? 0,
    //     extendedAttributes: {
    //       siteId: row?.siteAllSku,
    //       warehouseId: row?.warehouseAllSku
    //     },
    //     discountInfo: null,
    //     source: "DMS",
    //     supplier: orderData?.supplier,
    //     type: "normal",
    //   };
    // });
    // validOrderData.orderDetails = [...validOrderDetails, ...newRows];

    // const modifiedCart: any = await modifyCartToValidate(
    //   setCart,
    //   validOrderData
    // );
    // console.log(cart);

    // let editedSkus: string[] = [];
    // let editedCQ: number = 0;
    // let editedPQ: number = 0;
    // let editedOUQ: number = 0;

    // for (const row of rows) {
    //   if (
    //     (row?.actualCaseQuantity !== row?.caseQuantity) ||
    //     (row?.actualPieceQuantity !== row?.pieceQuantity) ||
    //     (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity)
    //   ) {
    //     // Accumulate the edited quantities if changes are detected
    //     if (row?.actualCaseQuantity !== row?.caseQuantity) {
    //       editedCQ += row?.actualCaseQuantity - row?.caseQuantity;
    //     }

    //     if (row?.actualPieceQuantity !== row?.pieceQuantity) {
    //       editedPQ += row?.actualPieceQuantity - row?.pieceQuantity;
    //     }

    //     if (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity) {
    //       editedOUQ += row?.actualOtherUnitQuantity - row?.otherUnitQuantity;
    //     }

    //     if ((editedCQ !== 0) || (editedPQ !== 0) || (editedOUQ !== 0)) {
    //       editedSkus.push(row?.batchCode);
    //     }
    //   }
    // }

    try {
      setOrderStatusChangeLoading("SAVE_CHANGES");
      // const requestBody: Record<any, any> | null = getValidateRequestBody(
      //   modifiedCart?.[validOrderData?.outletCode],
      //   validOrderData,
      //   undefined,
      //   undefined,
      //   undefined,
      //   undefined,
      //   undefined,
      //   id
      // );

      const flagToConfirmOriginalOrder =  (lineCount === checkedIdArray.length);
      console.log("confirm current order",flagToConfirmOriginalOrder);
      const requestBody =  prepareSaveChangesReqBody(filterRowsForPayload,orderData?.supplier, orderData?.loginId,orderData?.outletCode,orderData?.extendedAttributes?.tlc,flagToConfirmOriginalOrder , hasReferenceOrders);

      const response = await ChannelkartNetworkPost(
        "/orders/validate?transformerOut=orderDetailSplit",
        requestBody
      );
      if (response?.status === 200 || response?.status === 201) {
        const validateResponse = response?.data?.feature?.[0];
        delete validateResponse["creationTime"];
        const cleanedResponse = transformValidateResponse(validateResponse);
        
        await updateOrder(cleanedResponse, orderData?.orderNumber);
      }

      resetGenericModalProps();
      await refresh();
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", `Error while saving the changes`)
      );
    } finally {
      setClickSaveChangesLoading(false);
      setOrderStatusChangeLoading("");
    }
  };

  const refresh = async () => {
    try {
      setIsEditing(false);
      setLoader(true);
      await getOrderDetails(orderData?.id);
    } finally {
      setLoader(false);
    }
  };

  const resetRejectOrderState = () => {
    setOrderCancelModalOpen(false);
    setSelectedRejectionReason("");
  };

  const handleOrderStatusChange = async (id: string) => {
    const isCancellingOrderOrInvoice: boolean =
      id?.toUpperCase() == "REJECTED" || id?.toUpperCase() == "CANCELLED";

    const cancelInvoicePayload = {};

    const cancelInvoiceOrOrderPayload = isCancellingOrderOrInvoice
      ? { statusReason: selectedRejectionReason }
      : {};

    let requestBody = {
      status: id,
      ...cancelInvoicePayload,
      ...cancelInvoiceOrOrderPayload,
    };

    setOrderStatusChangeLoading(id);

    try {
      await updateOrderStatus(requestBody, orderData?.orderNumber);
      await getOrderDetails(orderId ? orderId : orderData?.id);

      resetGenericModalProps();
    } catch (e) {
      setGenericModalProps(
        getGenericModalProps("error", `Error while updating order status`)
      );
    } finally {
      setOrderStatusChangeLoading("");
      setIsEditing(false);
      if (isCancellingOrderOrInvoice) resetRejectOrderState();
    }
  };

  const handleClickAccept = async () => {
    if (openInvalidOrderModal()) return;

    await setDataRowAndFooter(orderData);

    const message = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? `Are you sure you want to confirm the order?`
      : `Ordered quantity is more than the available stock. Please edit the order to proceed.`;

    const fn = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? () => handleOrderStatusChange("CONFIRMED")
      : () => {
          setIsEditing(true);
          resetGenericModalProps();
        };

    const leftBtnText = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? "Yes"
      : "Edit";
    const rightBtnText = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? "No"
      : "";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      fn,
      resetGenericModalProps
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const prepareSubOrderReqBody = async () => {
    const selectedRows = getSelectedRowsData();
    const firstWarehouse = selectedRows[0]?.warehouseAllSku;

    const data = orderData;

    console.log("rows data", selectedRows);

    let sendAmount = 0;
    let fixSite = "";
    const quantityNodes: {
      batchCode: string;
      caseQuantity: number;
      otherUnitQuantity: number;
      pieceQuantity: number;
    }[] = [];

    const orderDetailsNodes = selectedRows.map((row) => {
      const foundCatalogue = catalogue.find(
        (catalogue: any) => catalogue.batchCode === row.batchCode
      );
      fixSite = row?.siteAllSku ?? "";

      sendAmount +=
        (row?.caseQuantity ?? 0) * (foundCatalogue?.casePtr ?? 0) +
        (row?.otherUnitQuantity ?? 0) * (foundCatalogue?.otherUnitPtr ?? 0) +
        (row?.pieceQuantity ?? 0) * (foundCatalogue?.packPtr ?? 0);

      quantityNodes.push({
        batchCode: row.batchCode,
        caseQuantity: row.caseQuantity ?? 0,
        otherUnitQuantity: row.otherUnitQuantity ?? 0,
        pieceQuantity: row.pieceQuantity ?? 0,
      });

      return {
        batchCode: row.batchCode,
        skuCode: row.batchCode,
        status: "CONFIRMED",
        casePrice: foundCatalogue?.casePtr ?? 0,
        caseQuantity: row.caseQuantity ?? 0,
        otherUnitPrice: foundCatalogue?.otherUnitPtr ?? 0,
        otherUnitQuantity: row.otherUnitQuantity ?? 0,
        pieceQuantity: row.pieceQuantity ?? 0,
        price: foundCatalogue?.packPtr ?? 0,
        // siteId: row?.siteAllSku,
        extendedAttributes: {
          warehouseId: row?.warehouseAllSku,
          retainId : row?.retainId,
          siteId: row?.siteAllSku
        },
        discountInfo: null,
        source: "OMS",
        supplier: data?.supplier,
        type: "normal",
      };
    });

    const requestBody = {
      billAmount: sendAmount,
      netAmount: sendAmount,
      creationTime: getCurrentDateTimeFormat(),

      discountInfo: null,
      extendedAttributes: {
        isNewSchemes: true,
        siteId: fixSite,
        warehouseId: firstWarehouse,
        orderSplitFromOms:true
      },
      finalOrderInfo: {
        quantity: quantityNodes,
        finalAmount: sendAmount.toString(),
      },

      freeItemInfo: [],
      lineCount: orderDetailsNodes.length,
      loginId: data?.loginId,
      orderDetails: orderDetailsNodes,
      outletCode: data?.outletCode,
      referenceNumber: `${data?.loginId}-${Date.now()}`,
      referenceOrderNumber: data?.orderNumber,
      remarks: "",
      source: "OMS",
      status: "CONFIRMED",
      submissionTime: getCurrentDateTimeFormat(),
      type: "primary",
    };

    return requestBody;
  };

  const handleCreateSubOrderChanges = async (id: boolean = false) => {
    if (clickSaveChangesLoading) return;

    setClickSaveChangesLoading(true);

    try {
      setOrderStatusChangeLoading("SAVE_CHANGES");
      const requestBody: any = await prepareSubOrderReqBody();

      const response = await ChannelkartNetworkPost(
        "/orders/validate?transformerOut=orderDetailSplit",
        requestBody
      );
      if (response?.status === 200 || response?.status === 201) {
        const validateResponse = response?.data?.feature?.[0];
        const orderReqBody = prepareOrderReqBody(
          JSON.parse(JSON.stringify(validateResponse)),
          OrderType.PRIMARY
        );

        const placedOrderResponse = await ChannelkartNetworkPost(
          "/orders",
          requestBody
        );

        if (
          placedOrderResponse?.status === 200 &&
          placedOrderResponse?.status === 201
        ) {
          console.log("order placed sucess");
        }
        // call post orders api
      }
      resetGenericModalProps();
      await refresh();
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", `Error while saving the changes`)
      );
    } finally {
      setClickSaveChangesLoading(false);
      setOrderStatusChangeLoading("");
    }
  };

  const createSubOrder = async () => {
    try {
      if (openInvalidOrderModal()) return;

      if (clickSaveChangesLoading) return;

      const selectedRows = getSelectedRowsData();
      // Validation: check all selected rows have the same site 
      const validateSameSiteAllSku = (rows: any[]) => {
          if (rows.length === 0) return true; 
          const firstSite = rows[0].siteAllSku;
          return rows.every((row) => row.siteAllSku === firstSite);
      };

      const isValid = validateSameSiteAllSku(selectedRows);

      if (!isValid) {
        setGenericModalProps(
          getGenericModalProps(
            "negative",
            "SKUs in this order are mapped to different sites"
          )
        );
        return;
      }
      console.log("create sub order")

      setClickSaveChangesLoading(true);

      const leftBtnFn = () => handleCreateSubOrderChanges();

      const rightBtnFn = async () => {
        setGenericModalProps(initialGenericModalProps);
        setClickSaveChangesLoading(false);
      };

      const leftBtnText = "Yes";
      const rightBtnText = "No";
      const message = `Are you sure you want to confirm the order ?`;

      const updatedGenericModalProps = getGenericModalProps(
        "positive",
        message,
        leftBtnText,
        rightBtnText,
        leftBtnFn,
        rightBtnFn,
        undefined,
        undefined,
        undefined,
        undefined,
        "455px"
      );
      setGenericModalProps(updatedGenericModalProps);
      setClickSaveChangesLoading(false);
    } catch (e) {
      console.log(e);
    } finally {
      setClickSaveChangesLoading(false);
    }
  };

  const handleClickSaveChanges = async () => {
    if (openInvalidOrderModal()) return;

    if (clickSaveChangesLoading) return;

    let filterRowsForPayload = validRows;

    filterRowsForPayload = filterRowsForPayload.filter(
      (row: viewManageOrderRowsData) => {
        // Keep if the row is new
        if (row?.isNew) return true;

        // Exclude if not new and all quantities are 0
        return (
          (row?.caseQuantity ?? 0) > 0 ||
          (row?.pieceQuantity ?? 0) > 0 ||
          (row?.otherUnitQuantity ?? 0) > 0
        );
      }
    );
    const selectedRowsData = filterRowsForPayload; // or whichever rows you want to validate

    // 1. Validate new rows have at least one quantity > 0
    const hasInvalidNewRow = selectedRowsData.some(
      (row) =>
        row?.isNew &&
        (row?.caseQuantity ?? 0) === 0 &&
        (row?.pieceQuantity ?? 0) === 0 &&
        (row?.otherUnitQuantity ?? 0) === 0
    );

    if (hasInvalidNewRow) {
      setGenericModalProps(
        getGenericModalProps(
          "negative",
          "For cloned rows, quantity must be greater than 0"
        )
      );
      return;
    }

    // 2. Validate siteAllSku and warehouseAllSku are selected for all rows
    const hasMissingSiteOrWarehouse = selectedRowsData.some(
      (row) => !row?.siteAllSku || !row?.warehouseAllSku
    );

    if (hasMissingSiteOrWarehouse) {
      setGenericModalProps(
        getGenericModalProps(
          "negative",
          "Site and Warehouse must be selected for all rows"
        )
      );
      return;
    }

    // 3. Validate batchCode + siteAllSku combination is unique
    const seenKeys = new Set<string>();
    const hasDuplicateBatchSite = selectedRowsData.some((row) => {
      const key = `${row?.batchCode}-${row?.siteAllSku}`;
      if (seenKeys.has(key)) return true;
      seenKeys.add(key);
      return false;
    });

    // if (hasDuplicateBatchSite) {
    //   setGenericModalProps(
    //     getGenericModalProps(
    //       "negative",
    //       "Duplicate batchCode and Site combination found"
    //     )
    //   );
    //   return;
    // }

    const validateSameSiteAllSku = (rows: any[]) => {
      if (rows.length === 0) return true; 
      const firstSite = rows[0].siteAllSku;
      return rows.every((row) => row.siteAllSku === firstSite);
  };

  const flagConfirmOrder = (lineCount === checkedIdArray.length)
  const isValid = validateSameSiteAllSku(selectedRowsData);

  if (!isValid && flagConfirmOrder) {
    setGenericModalProps(
      getGenericModalProps(
        "negative",
        "SKUs in this order are mapped to different sites"
      )
    );
    return;
  }

    setClickSaveChangesLoading(true);
    
    const isEmptyTable = checkForEmptyTable(validRows);
    if (!isEmptyTable) await setDataRowAndFooter(orderData);

    let message = ""
    let confirmOrder = `Are you sure you want to confirm the order?`
    let saveChanges = `Do you wish to save the changes made? ${
      isEmptyTable ? "Disclaimer: your order will be rejected." : ""
    }`;

    if(flagConfirmOrder) {
      console.log("confirm")
      message = confirmOrder
    }else {
      console.log("create sub order")
      message = saveChanges
    }

    const leftBtnFn =
      !validRows?.length || isEmptyTable
        ? () => handleOrderStatusChange("REJECTED")
        : checkAllRowsHaveValidStock(
            validRows,
            isEditing,
            disableStockCheck.current
          )
        ? () => handleSaveQuantityChanges(filterRowsForPayload)
        : () => resetGenericModalProps();

    const rightBtnFn = async () => {
      setGenericModalProps(initialGenericModalProps);
      setClickSaveChangesLoading(false);
      //   checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? resetGenericModalProps() : handleDisableEditing();
    };

    const leftBtnText = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? "Yes"
      : "Edit Order";
    const rightBtnText = checkAllRowsHaveValidStock(
      validRows,
      isEditing,
      disableStockCheck.current
    )
      ? "No"
      : "Close";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      leftBtnFn,
      rightBtnFn,
      undefined,
      undefined,
      undefined,
      undefined,
      "455px"
    );
    setGenericModalProps(updatedGenericModalProps);
    setClickSaveChangesLoading(false);
  };

  const handleReasonChange = (reason: string) => {
    setSelectedRejectionReason(reason);
  };

  const handleClickAddMore = async () => {
    if (openInvalidOrderModal()) {
      return;
    }

    if(!orderData?.siteId || !orderData?.warehouseId) {
      setGenericModalProps(getGenericModalProps("error", "Default site / warehouse not found"));
      return
    }

    setAddMoreLoading(true);

    const res = await populateCartDuringEditOrder(orderData, true);
    if (res === "invalidPricing") {
      setAddMoreLoading(false);
      return;
    }

    setAddMoreLoading(false);

    if (openInvalidOrderModal()) return;

    if (isEditing) {
      sessionStorage.setItem("addMorePressedWhileEditing", "true");
    }

    // below is the scenario, when he has edited something, and clicked on add more, so first edited will be saved then add more is done

    // Check if we're in editing mode and there are real changes
    // if (isEditing && hasRealChanges()) {
    //   // Check what the leftBtnText would be in the save changes modal
    //   const wouldShowYes = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current));

    //   if (wouldShowYes) {
    //     // If "Yes" would be shown, directly execute the save changes function

    //     console.log(cart);
    //     await handleSaveQuantityChanges();
    //     console.log(cart);

    //     // Then navigate as usual
    //     navigate(
    //       `/dashboard/primaryOms/manageOrders/addMore/${orderData?.id}?outletId=${orderData?.outletCode}`,
    //       { state: { isPrimaryOMS: true }});
    //   } else {
    //     // If "Edit Order" would be shown, show the modal
    //     await handleClickSaveChanges();
    //   }
    //   return;
    // }

    // run validations for add more
    let filterRowsForPayload = validRows;

    filterRowsForPayload = filterRowsForPayload.filter(
      (row: viewManageOrderRowsData) => {
        // Keep if the row is new
        if (row?.isNew) return true;

        // Exclude if not new and all quantities are 0
        return (
          (row?.caseQuantity ?? 0) > 0 ||
          (row?.pieceQuantity ?? 0) > 0 ||
          (row?.otherUnitQuantity ?? 0) > 0
        );
      }
    );
    const selectedRowsData = filterRowsForPayload; // or whichever rows you want to validate

    setTimeout(() => {
      navigate(
        `/dashboard/primaryOms/manageOrders/addMore/${orderData?.id}?outletId=${orderData?.outletCode}`,
        { state: { isPrimaryOMS: true , addMorePrimaryOmsRowsData: selectedRowsData 
        }}
      );
    }, 0);
  };

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <div
        className="view_order_parent_vo"
        onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}
      >
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          leftButtonPadding={genericModalProps?.leftButtonPadding}
          onClose={resetGenericModalProps}
          loading={Boolean(orderStatusChangeLoading?.length)}
          width={genericModalProps?.width}
        />

        <ScreenOverlay apply={showOverlay} />
        <div className="view_order_header_with_search">
          <div className="view_order_header">
            <FormHeader
              parentLabel={"Manage Orders"}
              label={"Order Details"}
              goBackToParent={() =>
                navigate(`/dashboard/primaryOms/manageOrders`)
              }
            />
          </div>
          <div className="view_order_manage_order_search_bar">
            <SearchV2 searchFunction={handleSearchValueChange} />
          </div>
        </div>

        <div
          ref={scrollRef}
          style={{
            gap: "14px",
            overflow: "auto",
            height: "100%",
            scrollbarWidth: ConfigDictionary?.showTableScrollbar ? "thin" : "none",
          }}
          onScroll={(e) => {
            if (ConfigDictionary?.showTableScrollbar){
              const currentScrollTop = e.currentTarget.scrollTop;
              if (currentScrollTop > scrollTop) {
                setIsScrolling(true); // scrolling down
              } else if (currentScrollTop < scrollTop) {
                setIsScrolling(false); // scrolling up
              } 
            }
          }}  
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderRadius: "10px",
              border: "1px solid #E7E7E7",
              padding: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "0px 5px",
              }}
            >
              <div
                style={{ display: "flex", gap: "6px", alignItems: "center" }}
              >
                <span style={{ fontSize: "14px", fontWeight: 500 }}>
                  {`Order No. ${orderData?.orderNumber}`}
                </span>
                •
                <span style={{ fontSize: "14px", fontWeight: 500 }}>
                  <span>{orderData?.outletName ?? ""}</span>{" "}
                  <span style={{ color: "#9F9F9F" }}>
                    {`(${orderData?.outletCode ?? ""})`}
                  </span>
                </span>
              </div>

              {(orderData?.status?.toUpperCase() === "PENDING" ||
                orderData?.status?.toUpperCase() === "CONFIRMED" ||
                orderData?.status?.toUpperCase() === "INVOICED" || orderData?.status?.toUpperCase() === "SPLITTED") && (
                <div style={{ alignSelf: "center" }}>
                  <OrderProgressCardV2
                    status={transformedStatusForProgressCardV2(
                      orderData?.status?.toUpperCase()
                    )}
                    trackingStagesList={orderTrackingConfig}
                    stages={stages}
                    insideManageInvoice={false}
                  />
                </div>
              )}
            </div>

            <CustomAccordianV2
              metaData1={getMetaData1ViewPrimaryOMSV2()}
              data1={orderData}
              moreDetails={[
                {
                  title: "Company details",
                  items: [
                    { label: "Name", value: orderData?.supplierName ?? "" },
                    { label: "Code", value: orderData?.supplier ?? "" },
                  ],
                },
                {
                  title: "Distributor details",
                  items: [
                    { label: "Name", value: orderData?.outletName ?? "" },
                    { label: "Code", value: orderData?.outletCode ?? "" },
                    { label: "City", value: orderData?.outletCity ?? "" },
                  ],
                },
                {
                  title: "Delivery details",
                  items: [
                    { label: "Est. Delivery Date", value: deliveryDatePrimary },
                    {
                      label: "Site ID",
                      value:
                        orderData?.siteId === null ||
                        orderData?.siteId === "null"
                          ? ""
                          : orderData?.siteId ?? "",
                    },
                    {
                      label: "Warehouse ID",
                      value:
                        orderData?.warehouseId === null ||
                        orderData?.warehouseId === "null"
                          ? ""
                          : orderData?.warehouseId ?? "",
                    },
                  ],
                },
                {
                  title: `Order details`,
                  items: [
                    {
                      label: `Order Date & Time`,
                      value: orderData?.creationTime,
                    },
                    ...(orderData?.referenceOrderNumber
                      ? [
                          {
                            label: 'Reference Order',
                            value: orderData?.referenceOrderNumber ?? "",
                          },
                        ]
                      : []),
                  ],
                },
              ]}
            />
          </div>

          <div style={{ height: "100%", position: "sticky", top: "0" }}>
            <div className="view_order_details_vo">
              <div className="view_order_button_container">
                <BorderHeading>{"Order Details"}</BorderHeading>

                {orderData?.status?.toUpperCase() === "PENDING" || orderData?.status?.toUpperCase() === "SPLITTED" && (
                  <TextSwitcher textSwitcherItems={textSwitcherItems ?? []} />
                )}

                {orderData?.status?.toUpperCase() === "PENDING" || orderData?.status?.toUpperCase() === "SPLITTED" ? (
                  <div style={{ display: "flex", gap: "8px" }}>
                    {disableActionButtons ? (
                      <Button
                        className="view_order_reset_button"
                        onClick={async () => {
                          if (editLoading) return;
                          setEditLoading(true);
                          await handleReset();
                          setEditLoading(false);
                        }}
                        disabled={editLoading}
                      >
                        <div className="view_order_icon_wrapper">
                          <RenderSvg name={"backIcon"} />
                        </div>{" "}
                        Reset changes
                      </Button>
                    ) : (
                      <></>
                    )}

                   {showAddMoreButton && !hasReferenceOrders && (
                     <Button
                     className="view_order_add_more_button"
                     variant="contained"
                     disabled={disableActionButtons}
                     color="primary"
                     onClick={() => {
                       if (!addMoreLoading) {
                         handleClickAddMore();
                       }
                     }}
                   >
                     <ShoppingCartIcon className="view_order_cart_icon" />
                     Add more
                     {addMoreLoading ? (
                       <>
                         &nbsp;
                         <CircularProgress
                           style={{ ...customStyle, height: 16, width: 16 }}
                         />
                       </>
                     ) : null}
                   </Button>
                    )}   
                   
                  </div>
                ) : (
                  <></>
                )}
              </div>

              {loader || editLoading ? (
                <Loader />
              ) : (
                <CustomTablewithTotalInfoV2
                  // data={filteredRows}
                  data={rows}
                  columns={columns}
                  allowTableScroll = {allowTableScroll}
                  isScrolling={isScrolling}
                  setScrollTop={setScrollTop}
                  totals={[]}
                  summaryFooterData={
                    orderData?.status?.toUpperCase() === "PENDING" || orderData?.status?.toUpperCase() === "SPLITTED" 
                      ? {
                          totalQuantityC: totalQ,
                          totalWeightC: totalW,
                          totalAmountC: totalF,
                        }
                      : {}
                  }
                  headerBackgroundColor="#F0FBFF"
                  isEditing={isEditing}
                  isCheckboxSelection={
                    orderData?.status?.toUpperCase() === "PENDING" || orderData?.status?.toUpperCase() === "SPLITTED"
                  }
                  checkedIdArray={checkedIdArray}
                  setCheckedIdArray={setCheckedIdArray}
                  selectableRowIds={allowedRows}
                  children={
                    orderData?.status?.toLowerCase() === "pending" || orderData?.status?.toLowerCase() === "splitted"? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          className="view_order_update_wrapper"
                          style={{ width: "100%", position: "static" }}
                        >
                          <div
                            className="view_order_action_buttons_wrapper"
                            style={{ gap: "5px" }}
                          >
                            <>
                              {disableActionButtons && (
                                <span
                                  style={{
                                    marginRight: "8px",
                                    textWrap: "nowrap",
                                    padding: "4px 8px",
                                    borderRadius: "20px",
                                    background: "#FFF7F7",
                                    color: "#B54747",
                                    fontSize: "11px",
                                  }}
                                >
                                  * Tax, promos, and amount update after saving
                                  changes.
                                </span>
                              )}

                              {/* save changes after editing first */}
                              <Button
                                className="view_order_action_button"
                                key="SAVE"
                                disabled={
                                  !disableActionButtons ||
                                  clickSaveChangesLoading ||
                                  checkedIdArray.length > 0
                                }
                                sx={{
                                  cursor:
                                    (disableActionButtons &&
                                      !clickSaveChangesLoading) ||
                                    checkedIdArray.length > 0
                                      ? "pointer !important"
                                      : "not-allowed !important",
                                  color: "#ffffff !important",
                                  fontWeight: 500,
                                  fontSize: "12px !important",
                                  backgroundColor:
                                    disableActionButtons &&
                                    !clickSaveChangesLoading
                                      ? "#227C9D !important"
                                      : "#E2E2E2 !important",
                                  letterSpacing: "0.0001rem",
                                  textTransform: "none",
                                  minHeight: "35px",
                                  minWidth: "75px",
                                }}
                                onClick={async () => {
                                  //   if(hasNewRows && checkedIdArray.length === 0){
                                  //     setGenericModalProps(
                                  //       getGenericModalProps(
                                  //       "positive",
                                  //       `No SKU are selected to split order`
                                  //        )
                                  //      );
                                  //    return;
                                  //  } else if(checkedIdArray.length > 0){
                                  //     const selectedRowsData = getSelectedRowsData();
                                  //     const isAllSiteSame = selectedRowsData.every(row => row?.siteAllSku === selectedRowsData[0]?.siteAllSku);
                                  //     const batchCodes = selectedRowsData.map(row => row?.batchCode);

                                  //       // create a Set to get unique batch codes
                                  //       const uniqueBatchCodes = new Set(batchCodes);

                                  //       // check if all batch codes are distinct
                                  //       const allDistinct = uniqueBatchCodes.size === batchCodes.length;

                                  //       // selected rows quantities must be  > 0, caseQuantity, pieceQuantity, otherUnitQuantity
                                  //       const isAnyQuantityPositive = selectedRowsData.every(
                                  //         row => row?.caseQuantity > 0 || row?.pieceQuantity > 0 || row?.otherUnitQuantity > 0
                                  //       );

                                  //     if(!isAllSiteSame){
                                  //       setGenericModalProps(
                                  //         getGenericModalProps(
                                  //         "positive",
                                  //         `SKUs in this order are mapped to different sites`
                                  //         )
                                  //       );
                                  //       return;
                                  //     } else if(!allDistinct){
                                  //        // all batchcode must be different

                                  //       setGenericModalProps(
                                  //         getGenericModalProps(
                                  //         "positive",
                                  //         `Duplicate batch codes found for SKUs in this order`
                                  //         )
                                  //       );
                                  //       return;
                                  //     } else if(!isAnyQuantityPositive) {
                                  //       setGenericModalProps(
                                  //         getGenericModalProps(
                                  //         "positive",
                                  //         `Each selected row must have at least one quantity greater than 0.`
                                  //         )
                                  //       );
                                  //       return;
                                  //     }

                                  //  }

                                  if (editLoading || clickSaveChangesLoading)
                                    return;
                                  setEditLoading(true);
                                  await handleClickSaveChanges();
                                  setEditLoading(false);
                                }}
                              >
                                {clickSaveChangesLoading ? (
                                  <CircularProgress style={customStyle} />
                                ) : (
                                  "Save"
                                )}
                              </Button>

                              {/* cancel order */}
                              {/* add a check , if from reference order number API , data is coming, do not show this , cancel */}
                               
                              { !hasReferenceOrders && (
                                                              <Button
                                                              className="view_order_action_button"
                                                              key="REJECTED"
                                                              disabled={
                                                                disableActionButtons ||
                                                                checkedIdArray.length > 0
                                                              }
                                                              sx={{
                                                                cursor:
                                                                  disableActionButtons ||
                                                                  checkedIdArray.length > 0
                                                                    ? "not-allowed !important"
                                                                    : "pointer !important",
                                                                color: "#ffffff !important",
                                                                fontWeight: 500,
                                                                fontSize: "12px !important",
                                                                backgroundColor:
                                                                  disableActionButtons ||
                                                                  checkedIdArray.length > 0
                                                                    ? "#E2E2E2 !important"
                                                                    : "#C64C00 !important",
                                                                letterSpacing: "0.0001rem",
                                                                textTransform: "none",
                                                                minHeight: "35px",
                                                                minWidth: "75px",
                                                              }}
                                                              onClick={() => setOrderCancelModalOpen(true)}
                                                            >
                                                              {buttonLoading(
                                                                orderStatusChangeLoading,
                                                                "REJECTED"
                                                              ) ? (
                                                                <CircularProgress style={customStyle} />
                                                              ) : (
                                                                "Cancel"
                                                              )}
                                                            </Button>
                              

                              )}

                              {/* confirm order */}
                              <Button
                                className="view_order_action_button"
                                key="CONFIRM"
                                disabled={checkedIdArray.length === 0}
                                sx={{
                                  cursor:
                                    checkedIdArray.length === 0
                                      ? "not-allowed !important"
                                      : "pointer !important",
                                  color: "#ffffff !important",
                                  fontWeight: 500,
                                  fontSize: "12px !important",
                                  backgroundColor:
                                    checkedIdArray.length === 0
                                      ? "#E2E2E2 !important"
                                      : "#00c6b1 !important",
                                  letterSpacing: "0.0001rem",
                                  textTransform: "none",
                                  minHeight: "35px",
                                  minWidth: "75px",
                                }}
                                onClick={ (lineCount === checkedIdArray.length) ? handleClickSaveChanges : createSubOrder}
                              >
                                {false ? (
                                  <CircularProgress style={customStyle} />
                                ) : (
                                  "Confirm"
                                )}
                              </Button>
                            </>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <OrderCancelModal
        headerText={`Order is being cancelled.`}
        modalOpen={orderCancelModalOpen}
        selectedRejectionReason={selectedRejectionReason}
        loading={buttonLoading(orderStatusChangeLoading, "REJECTED")}
        rejectionReasons={rejectionReasons}
        onClose={resetRejectOrderState}
        handleReasonChange={handleReasonChange}
        onButtonClick={() =>
          handleOrderStatusChange(getOrderCancellationStatusId())
        }
      />
    </>
  );
};

export default ViewPrimaryOrderOMSTest;
